import React from 'react';

export function Covid() {
  return (
    <div className="space-y-4">
      <div className="bg-primary rounded-lg p-4 text-center h-[50px] flex items-center justify-center">
        <h1 className="text-xl text-white">PROTOCOLO COVID-19</h1>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="space-y-3">
          <p className="text-gray-700 font-semibold">Recuerda:</p>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li>Ven solo con cita previa</li>
            <li>Acude a tu cita con mascarilla</li>
            <li>No llegues antes de tu hora</li>
            <li>Anula tu cita si tienes síntomas relacionados con el covid-19</li>
            <li>No acudas con acompañantes que no vayan a realizarse ningún tratamiento</li>
          </ul>
        </div>
      </div>
    </div>
  );
}